(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petomg-photo-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('petomg-photo-gallery')){
class PetomgPhotoGallery extends HTMLElement{
connectedCallback(){if(this.initialized)return;this.initialized=true;this.abort=new AbortController();const on=(el,event,fn)=>el.addEventListener(event,fn,{signal:this.abort.signal});this.cards=[...this.querySelectorAll('.pg-card')];this.dialog=this.querySelector('.pg-dialog');this.more=this.querySelector('.pg-more');this.mq=matchMedia('(max-width:700px)');this.expanded=false;this.active=0;this.imageRequest=0;this.trigger=null;
this.cards.forEach((card,i)=>on(card.querySelector('.pg-open'),'click',e=>{this.active=i;this.trigger=e.currentTarget;this.updateModal();this.dialog.showModal();document.documentElement.classList.add('pg-lock')}));
on(this.more,'click',()=>{if(this.expanded){this.expanded=false;this.render();this.more.scrollIntoView({block:'center',behavior:'auto'});return}const old=this.visibleCount();this.expanded=true;this.render();this.cards[old]?.querySelector('.pg-open').focus()});on(this.mq,'change',()=>this.render());
on(this.querySelector('.pg-close'),'click',()=>this.dialog.close());on(this.dialog,'close',()=>{this.unlock();this.trigger?.focus()});on(this.dialog,'click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()});
on(this.querySelector('.pg-prev'),'click',()=>this.move(-1));on(this.querySelector('.pg-next'),'click',()=>this.move(1));on(this.dialog,'keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();this.move(e.key==='ArrowRight'?1:-1)});
on(document,'shopify:block:select',e=>{const card=e.target.closest?.('.pg-card');if(card&&this.contains(card)){this.expanded=true;this.render();card.scrollIntoView({block:'center',behavior:'auto'})}});this.render();}
initialCount(){return Math.min(this.cards.length,Number(this.mq.matches?this.dataset.mobile:this.dataset.desktop)||4)}
visibleCount(){return this.expanded?this.cards.length:this.initialCount()}
render(){const count=this.visibleCount();this.cards.forEach((card,i)=>{card.hidden=i>=count});this.more.hidden=this.initialCount()>=this.cards.length;this.more.setAttribute('aria-expanded',String(this.expanded));this.more.querySelector('.pg-more-text').hidden=this.expanded;this.more.querySelector('.pg-less-text').hidden=!this.expanded;this.querySelector('.pg-count').textContent=this.dataset.countTemplate.replace('[shown]',count).replace('[total]',this.cards.length);this.querySelector('.pg-bottom').hidden=!this.cards.length;}
updateModal(){if(!this.cards.length)return;const card=this.cards[this.active],button=card.querySelector('.pg-open'),img=this.querySelector('.pg-large'),thumb=button.querySelector('img'),request=++this.imageRequest;img.src=thumb.currentSrc||thumb.src||button.dataset.full;img.alt=thumb.alt;if(button.dataset.full&&button.dataset.full!==img.src){const full=new Image();full.onload=()=>{if(this.imageRequest===request)img.src=full.src};full.src=button.dataset.full}this.querySelector('.pg-modal-title').textContent=button.dataset.title;const label=this.querySelector('.pg-modal-label');label.textContent=button.dataset.label;label.hidden=!label.textContent;this.querySelector('.pg-description').replaceChildren(card.querySelector('template').content.cloneNode(true));const link=this.querySelector('.pg-link');link.hidden=!button.dataset.url||!button.dataset.cta;link.textContent=button.dataset.cta;if(button.dataset.url)link.setAttribute('href',button.dataset.url);else link.removeAttribute('href');this.querySelector('.pg-position').textContent=(this.active+1)+' / '+this.cards.length;this.querySelector('.pg-prev').disabled=this.cards.length<2;this.querySelector('.pg-next').disabled=this.cards.length<2;}
move(delta){this.active=(this.active+delta+this.cards.length)%this.cards.length;this.updateModal()}
unlock(){if(!document.querySelector('petomg-photo-gallery dialog[open]'))document.documentElement.classList.remove('pg-lock')}
disconnectedCallback(){this.abort?.abort();if(this.dialog?.open)this.dialog.close();this.unlock();this.initialized=false;}
}
customElements.define('petomg-photo-gallery',PetomgPhotoGallery);
}


  } catch(e) { console.error(e); }
})();
})();
